import React from 'react';

/**
 * DetailCertText
 * 
 * Displays the appropriate certification text based on
 * RDS, RSD, GRS, and Treatment status.
 * Replaces the text-displaying logic from RDSCertified.
 */
export const DetailCertText = ({ isRsd, isRds, isGrs, isTreatment, t }) => {
  const getLabelKey = () => {
    if (isRsd && isRds) return "certs.rsd";
    if (isRsd && isTreatment) return "certs.rsd";
    if (isRsd && !isTreatment) return "certs.rsd_oeko";
    if (!isRsd && isRds && isTreatment) return "certs.rds";
    if (!isGrs && !isRsd && isRds && !isTreatment) return "certs.rds_oeko";
    if (isGrs && isTreatment) return "certs.grs_bluesign";
    if (isGrs === false && !isTreatment) return null; // Explicitly handle false for GRS
    if (isGrs && !isTreatment) return "certs.grs_oeko"; // Assuming GRS + no treatment defaults to Oeko
    return "certs.grs_oeko"; // Default fallback (GRS / bluesign / OEKO-TEX® Standard 100)
  };

  const labelKey = getLabelKey();
  if (!labelKey) return null;

  return (
    <p className="spec-value">{t(labelKey)}</p>
  );
};
